import { Box, styled } from "@mui/material";

const ContentSectionRowRoot = styled(Box)({
  flex: 1,
  display: "flex",
  flexDirection: "row",
  overflow: "hidden",
});

const ContentSectionRow = ({ children, className, sx, ...rest }) => (
  <ContentSectionRowRoot className={className} sx={sx} {...rest}>
    {children}
  </ContentSectionRowRoot>
);

export default ContentSectionRow;
